import { useLanguageContext } from "../../../context/LanguageContext";
import MessageTemplatePage from "../../../pages/message_templates/message_template/MessageTemplatePage";
import { useMessageTemplateCreateRouteValidator } from "../../validators/message_templates/MessageTemplateCreateRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useMessageTemplatesRouteConfig from "./MessageTemplatesRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useMessageTemplateCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/message_templates/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.message_template"),
        },
      ])
    )
    .setValidator(useMessageTemplateCreateRouteValidator())
    .setPage(<MessageTemplatePage />)
    .setParent(useMessageTemplatesRouteConfig());
}

export default useMessageTemplateCreateRouteConfig;
